module.exports = __webpack_public_path__ + "static/media/s_sf_13.ee2c38ce.png";